
import React from 'react';

// Comps
import {Headings} from '@arctheme-components/elements/Headings/Headings';
import {Paragraph} from '@arctheme-components/elements/Paragraph/Paragraph';

type Props = {
    title?: string;
    titleType?: string;
    tagline?: string;
    taglineType?: string;
    colorSchema?: string;
};

const AccountFormHeader = ({ title, titleType, tagline, taglineType, colorSchema }: Props) => {
    if (!title && !tagline) return null;

    return (
        <div className={`hidden color-${colorSchema} border-b border-black`}>
            {title && (
                <Headings type='h4' classes={`${titleType} mb-2`}>
                    {title}
                </Headings>
            )}

            {tagline && (
                <Paragraph text={tagline} type={taglineType}/>
            )}
        </div>
    );
};

export default AccountFormHeader;
